var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUniversityGeneralMaletofemale(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "student_1_",
    "data-name": "student (1)",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55205",
    "data-name": "Path 55205",
    d: "M333.8,154.893l-4.3-2.149a1.2,1.2,0,0,0-1.074,0l-4.3,2.151a5.035,5.035,0,0,0-2.8,4.527v5.334a1.2,1.2,0,0,0,1.2,1.2H335.4a1.2,1.2,0,0,0,1.2-1.2V159.42A5.032,5.032,0,0,0,333.8,154.893Z",
    transform: "translate(-295.601 -140.396)",
    fill: "#b2ece4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55206",
    "data-name": "Path 55206",
    d: "M12.47,154.893l-4.3-2.149a1.2,1.2,0,0,0-1.074,0l-4.3,2.151A5.035,5.035,0,0,0,0,159.422v5.334a1.2,1.2,0,0,0,1.2,1.2H14.067a1.2,1.2,0,0,0,1.2-1.2V159.42A5.032,5.032,0,0,0,12.47,154.893Z",
    transform: "translate(0 -140.396)",
    fill: "#63c5b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55207",
    "data-name": "Path 55207",
    d: "M173.136,114.743l-4.3-2.149a1.2,1.2,0,0,0-1.074,0l-4.3,2.151a5.035,5.035,0,0,0-2.8,4.527v8.549a1.2,1.2,0,0,0,1.2,1.2h12.866a1.2,1.2,0,0,0,1.2-1.2V119.27a5.032,5.032,0,0,0-2.8-4.527Z",
    transform: "translate(-147.8 -103.461)",
    fill: "#aee0d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55208",
    "data-name": "Path 55208",
    d: "M260.836,114.742l-4.3-2.149a1.2,1.2,0,0,0-.537-.127v16.555h6.433a1.2,1.2,0,0,0,1.2-1.2v-8.551A5.032,5.032,0,0,0,260.836,114.742Z",
    transform: "translate(-235.5 -103.461)",
    fill: "#63c5b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55209",
    "data-name": "Path 55209",
    d: "M94.214,242.314a21.823,21.823,0,0,0-6.028-1.286c-3.734-.225-6.657.788-8.564,2.944-1.907-2.156-4.83-3.169-8.564-2.944a21.823,21.823,0,0,0-6.028,1.286,1.2,1.2,0,0,0-.762,1.118v15.46a1.2,1.2,0,0,0,1.641,1.118,19.528,19.528,0,0,1,5.293-1.124c3.572-.215,6.053.862,7.373,3.2a1.2,1.2,0,0,0,2.092,0c1.314-2.327,3.776-3.406,7.32-3.2a19.683,19.683,0,0,1,5.347,1.127,1.2,1.2,0,0,0,1.641-1.118v-15.46a1.2,1.2,0,0,0-.762-1.118Z",
    transform: "translate(-59.122 -221.699)",
    fill: "#dff9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55210",
    "data-name": "Path 55210",
    d: "M256,262.7a1.2,1.2,0,0,0,1.046-.611c1.314-2.327,3.776-3.406,7.32-3.2a19.68,19.68,0,0,1,5.347,1.127,1.2,1.2,0,0,0,1.641-1.118v-15.46a1.2,1.2,0,0,0-.762-1.118,21.823,21.823,0,0,0-6.028-1.286c-3.734-.225-6.657.788-8.564,2.944Z",
    transform: "translate(-235.5 -221.699)",
    fill: "#aee0d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55211",
    "data-name": "Path 55211",
    d: "M133.353,372.316a12.152,12.152,0,0,0-3.51-.143,1.2,1.2,0,1,1-.217-2.393,14.537,14.537,0,0,1,4.209.182,1.2,1.2,0,1,1-.482,2.354Z",
    transform: "translate(-118.24 -340.102)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55212",
    "data-name": "Path 55212",
    d: "M133.352,307.964a12.151,12.151,0,0,0-3.511-.144,1.2,1.2,0,1,1-.217-2.393,14.541,14.541,0,0,1,4.209.183,1.2,1.2,0,0,1-.482,2.354Z",
    transform: "translate(-118.239 -280.903)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55213",
    "data-name": "Path 55213",
    d: "M306.7,372.316a12.153,12.153,0,0,1,3.51-.143,1.2,1.2,0,0,0,.217-2.393,14.537,14.537,0,0,0-4.209.182,1.2,1.2,0,1,0,.482,2.354Z",
    transform: "translate(-280.818 -340.102)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55214",
    "data-name": "Path 55214",
    d: "M306.705,307.964a12.151,12.151,0,0,1,3.511-.144,1.2,1.2,0,1,0,.217-2.393,14.541,14.541,0,0,0-4.209.183,1.2,1.2,0,0,0,.482,2.354Z",
    transform: "translate(-280.818 -280.903)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2807",
    "data-name": "Ellipse 2807",
    cx: 5.704,
    cy: 5.704,
    r: 5.704,
    transform: "translate(1.93 3.215)",
    fill: "#aee0d9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2808",
    "data-name": "Ellipse 2808",
    cx: 5.704,
    cy: 5.704,
    r: 5.704,
    transform: "translate(14.796 0)",
    fill: "#63c5b7"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2809",
    "data-name": "Ellipse 2809",
    cx: 5.704,
    cy: 5.704,
    r: 5.704,
    transform: "translate(27.662 3.215)",
    fill: "#63c5b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55215",
    "data-name": "Path 55215",
    d: "M256,0a5.7,5.7,0,0,1,0,11.408Z",
    transform: "translate(-235.5 0)",
    fill: "#387f75"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniversityGeneralMaletofemale);
export default __webpack_public_path__ + "static/media/university-general-maletofemale.7b700e2ad48d41d1e45b9ce81eb25932.svg";
export { ForwardRef as ReactComponent };